// extracted by mini-css-extract-plugin
module.exports = {"PolicyBodyTabs":"PolicyBodyTabs___1311H","PolicyBodyTabActivated":"PolicyBodyTabActivated___2VUBE","PolicyBodyContainer":"PolicyBodyContainer___3CJRf"};